import React from "react";
import utils from "../../modules/utils";
import Stepper from "../shared/stepper.js";
import ModalError from "../shared/modal_errore.js";
import FormDatiPersonali from "./form.js";
import { clearHistoryBack } from "../../actions/index";
import { connect } from "react-redux";
import { trackPageView, trackCFRiconosciuto } from "../../modules/datalayer.js";
import "./dati_personali.css";

const mapDispatchToProps = dispatch => {
  return {
    clearHistoryBack: c => dispatch(clearHistoryBack(c))
  };
};

class DatiPersonali extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      recap_visible: false
    };
  }
  componentDidMount() {
    const gState = utils.getState();
    if (gState.modificando) {
      this.setState({
        recap_visible: true
      });
    }

    //Modificato 2019-11-29
    trackPageView("dati-personali");

    /*if (typeof gState != "undefined" && typeof gState.utente != "undefined" && typeof gState.utente.nome != "undefined" && gState.utente.nome != "") { //Tracciamento custom
      console.log("Tracking CF riconosciuto")
      trackCFRiconosciuto();
    } else { //Tracciamento standard
      console.log("Tracking Standard") 
      trackPageView('dati-personali');
    }*/

    utils.animate.slideIn(utils.getState().dati_locali.historyBack);
    utils.animate.zoomIn();
    this.props.clearHistoryBack();
  }
  render() {
    const global_state = utils.getState();

    let titleSection = null;

    if (global_state.prodotto == 5) {
      titleSection = (
        <section className="registrazione-AUP">
          <h2 className="registrazione-AUP__title">Prestito Business</h2>
          <h4 className="registrazione-AUP__subtitle">Fino a 50.000 € per la tua attività.</h4>
        </section>
      );
    }

    return (
      <div id="dati_personali">
        <Stepper percentage="80" />
        <ModalError />
        <div className="grid-container">
          { titleSection }
          <FormDatiPersonali />
        </div>
      </div>
    );
  }
}

export default connect(null, mapDispatchToProps)(DatiPersonali);



// WEBPACK FOOTER //
// ./src/components/dati_personali/index.js